import { ChangeEvent, useState } from 'react';
import { TextField } from './TextField';

export interface DialogTextFieldProps {
  placeholder: string;
  setValue: (value: string) => void;
  value: string | null;
  autoFocus?: boolean;
  type?: string;
  margin?: 'dense' | 'normal' | 'none';
  isValid?: boolean;
  multiline?: boolean;
  rows?: number;
}

export default function DialogTextField({
  placeholder,
  setValue,
  value,
  autoFocus,
  type = 'string',
  margin = 'dense',
  isValid = true,
  multiline,
  rows,
}: DialogTextFieldProps) {
  const [touched, setTouched] = useState(false);
  function onChange(event: ChangeEvent<HTMLInputElement>) {
    const { value: newValue } = event.target;
    setValue(newValue);
  }

  return (
    <TextField
      autoFocus={autoFocus}
      fullWidth
      margin={margin}
      placeholder={placeholder}
      onChange={onChange}
      value={value || ''}
      type={type}
      multiline={multiline}
      rows={rows}
      sx={{ border: isValid || !touched ? '' : '1px solid red' }}
      onBlur={() => {
        setTouched(true);
      }}
    />
  );
}
